import { render } from "./myhotelorder.vue?vue&type=template&id=31378de4&scoped=true"
import script from "./myhotelorder.vue?vue&type=script&lang=js"
export * from "./myhotelorder.vue?vue&type=script&lang=js"

import "./myhotelorder.vue?vue&type=style&index=0&id=31378de4&lang=scss"
import "./myhotelorder.vue?vue&type=style&index=1&id=31378de4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31378de4"]])

export default __exports__